import { BaseModel } from '@core/data-access';
import { Expose } from 'class-transformer';

export interface NDIInterface {
  signRef: string;
  expiresAt: number;
  qrCode: {
    logo: string;
    payload: string;
  };
  docName: string;
  docHash: string;
}

export class NDIModel extends BaseModel implements NDIInterface {
  signRef!: string;
  expiresAt!: number;
  challengeCode!: string;
  qrCode!: {
    logo: string;
    payload: string;
  };
  docName!: string;
  docHash!: string;
}

export class NDIStatus extends BaseModel {
  @Expose()
  signRef!: string;

  @Expose()
  status!: string;

  @Expose()
  challengeCode!: string;

  @Expose()
  currentProcess!: 'initialized' | 'received-cert' | 'received-signature';

  @Expose()
  signatureName!: string;

  @Expose()
  signatureTime!: string;

  @Expose()
  signedDocUrl!: string;
}
